export default function getBannerData(banner, { parent = {}, limit, transform }) {
  const entity = banner.entity || parent.itemEntity;
  return { ...banner, entity, parent, limit, transform };
}
